/* Barklie: met de muis slepen om opzij te scrollen (zoals data-wf-drag-scroll op de referentiesite).
   Werkt op elk element met [data-bk-drag]; aanraakschermen scrollen gewoon zelf. */
(function () {
  function bind(el) {
    if (el.dataset.bkDragBound) return;
    el.dataset.bkDragBound = '1';
    var startX = 0, startLeft = 0, moved = false, down = false;
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; startX = e.clientX; startLeft = el.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 4) { moved = true; el.classList.add('is-dragging'); el.style.scrollSnapType = 'none'; }
      if (moved) el.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      el.classList.remove('is-dragging');
      el.style.scrollSnapType = '';
    });
    el.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }
  function init() { document.querySelectorAll('[data-bk-drag]').forEach(bind); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
